import { Component, OnInit } from '@angular/core';
import { TestViewViewModel } from 'src/app/shared/models/test.model';

import { TestService } from 'src/app/shared/test.service';
import { MatIcon } from '@angular/material/icon';
import { MatAnchor } from '@angular/material/button';
import { RouterLink } from '@angular/router';

import { ConfigTestViewCardComponent } from '../config-test-view-card/config-test-view-card.component';
import { MatDivider } from '@angular/material/divider';

@Component({
    selector: 'app-config-test-view-list',
    templateUrl: './config-test-view-list.component.html',
    styleUrls: ['./config-test-view-list.component.css'],
  imports: [MatIcon, MatAnchor, RouterLink, ConfigTestViewCardComponent, MatDivider]
})
export class ConfigTestViewListComponent implements OnInit {

  TestViews: TestViewViewModel[];

  constructor(public testService: TestService) { }

  ngOnInit(): void {

    this.testService.getAllTestViews().subscribe(data=>{
      //console.log(data);
      this.TestViews = data as TestViewViewModel[];
    });
  }

  refresh(){
    this.testService.getAllTestViews().subscribe(data=>{
      //console.log(data);
      this.TestViews = data as TestViewViewModel[];
    });
  }

}
